export default "__VITE_ASSET__hrfCqYyW__"